import { FLAG_LABELS, type EffectiveFlag, type FlagStatus } from "../../shared/flags.ts";

// Every flag carries a text label, so color is never the only signal.
const STYLE: Record<FlagStatus | "new", string> = {
  new: "bg-coral text-white",
  private_preview: "bg-sky text-ink ring-1 ring-inset ring-ink/15",
  public_preview: "bg-sky text-ink",
  beta: "bg-lilac text-ink",
  ga: "bg-mint text-ink",
  deprecated: "bg-peach text-ink ring-1 ring-inset ring-[#b5651d]/50",
  retired: "bg-ink text-white",
};

export function FlagChip({ status, count, size = "sm" }: { status: FlagStatus | "new"; count?: number; size?: "sm" | "md" }) {
  const pad = size === "md" ? "px-2 py-0.5 text-xs" : "px-1.5 py-px text-2xs";
  return (
    <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full font-semibold leading-4 ${pad} ${STYLE[status]}`}>
      {FLAG_LABELS[status]}
      {count !== undefined && count > 1 && <span className="tabular-nums opacity-90">{count}</span>}
    </span>
  );
}

/** Flag plus where it came from, linked to the evidence. */
export function FlagEvidence({ flag, isSample }: { flag: EffectiveFlag; isSample: boolean }) {
  const label = isSample ? "sample label" : flag.source === "verified" ? "✓ verified by editors" : "per official release note";
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      <FlagChip status={flag.status} size="md" />
      {isSample ? (
        <span className="text-xs italic text-ink-soft">{label}</span>
      ) : (
        <a href={flag.url} target="_blank" rel="noopener noreferrer" className="text-xs text-ink underline decoration-line-strong underline-offset-[3px] hover:decoration-ink">
          {label}
          <span className="sr-only"> (opens in a new tab)</span>
        </a>
      )}
    </span>
  );
}
